import { FC, useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { SubFilterProps } from "./SubFilter.types";
import { IS_WEB } from "../../../../constants/platform";
import { addBase64Prefix } from "../../../../services/addBase64Prefix";
import { filter_button } from "../../../../assets/base64";
import { COLORS, FONTS } from "../../../../constants";
import {decode} from 'html-entities';

const SubFilter: FC<SubFilterProps> = ({
  selectedFilter,
  handleSubFilterSelect,
  filterSelected,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <TouchableOpacity
      onPress={() => setOpen(!open)}
    >
      <View
        style={[
          { 
            flexDirection: 'row',
            marginBottom: 20,
            paddingVertical: 5,
            paddingEnd: 5,
          },
          open && {
            backgroundColor: COLORS.GREEN
          }
        ]}
      >
        <View>
          <Image
            source={
              IS_WEB
                ? addBase64Prefix(filter_button)
                : require('../../../../assets/filter-button.png')
            }
            style={[
              { width: 13, height: 13, marginRight: 8, marginLeft: 3 },
              open && {
                tintColor: COLORS.WHITE,
              }
            ]}
          />
        </View>
        <Text style={[styles.selectedText, open && {color: COLORS.WHITE}]}>
          ALL {decode(selectedFilter.name)}
        </Text>
      </View>
      { open && (
        <View style={{
          position: 'absolute',
          top: 25,
          backgroundColor: COLORS.GREEN,
          paddingHorizontal: 20,
          paddingVertical: 20,
        }}>
          {selectedFilter.child?.map((filter) => (
            <TouchableOpacity
              key={filter.id}
              style={[
                styles.selectWrapper,
                { alignSelf: 'flex-start' },
              ]}
              onPress={() => handleSubFilterSelect(filter)}
            >
              <View style={styles.selectedBox}>
                {filterSelected.includes(filter) && (
                <View
                  style={{
                    width: '100%',
                    height: '100%',
                    borderColor: COLORS.WHITE,
                    borderWidth: 4,
                  }}
                ></View>
                )}
              </View>
              <Text style={styles.selectedSubText}>{decode(filter.name)}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </TouchableOpacity>
  )
}

export default SubFilter

const styles = StyleSheet.create({
  selectedText: {
    fontSize: 12,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  selectedSubText: {
    fontSize: 12,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.WHITE,
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  selectedBox: {
    width: 18,
    height: 18,
    borderWidth: 2,
    borderColor: COLORS.WHITE,
    borderRadius: 2,
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  selectWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
})